import { render, staticRenderFns } from "./WorkflowInvocationHeader.vue?vue&type=template&id=1e2b5318"
import script from "./WorkflowInvocationHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowInvocationHeader.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports